<template>
  <div id="sectionPrint">
    <div class="container">
      <invoice-header
        :orderInfo="data"
        :class="hidden ? 'print:flex hidden' : ''"
        class="mb-5"
      ></invoice-header>
      <div class="section-info">
        <div class="pt-8 mb-8">
          <div class="rounded-md p-3 border border-gray-300 relative text-sm">
            <div
              class="title font-bold mb-5 absolute -top-3 px-5 right-5 bg-indigo-50"
            >
              {{ sectionTitle }}
              <span v-if="pageLabel" class="text-gray-500 mr-2">{{ pageLabel }}</span>
            </div>

            <!-- Layout: 3 images (1 large + 2 small) -->
            <div v-if="layout === 'three'" class="image-layout-three">
              <div v-if="images[0]" class="featured-image">
                <img
                  :src="images[0].image"
                  class="rounded-lg border-2 border-gray-200 shadow-sm"
                  alt=""
                />
              </div>
              <div class="bottom-row">
                <div v-if="images[1]" class="bottom-image">
                  <img
                    :src="images[1].image"
                    class="rounded-lg border-2 border-gray-200 shadow-sm"
                    alt=""
                  />
                </div>
                <div v-if="images[2]" class="bottom-image">
                  <img
                    :src="images[2].image"
                    class="rounded-lg border-2 border-gray-200 shadow-sm"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- Layout: 2 images (side by side, larger) -->
            <div v-else-if="layout === 'two'" class="image-layout-two">
              <div v-for="(img, index) in images" :key="index" class="large-image">
                <img
                  :src="img.image"
                  class="rounded-lg border-2 border-gray-200 shadow-sm"
                  alt=""
                />
              </div>
            </div>

            <!-- Fallback: default grid -->
            <div v-else class="image-grid">
              <div v-for="(img, index) in images" :key="index" class="image-item">
                <img
                  :src="img.image"
                  class="rounded-md border border-gray-200"
                  alt=""
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* Layout: 3 images - 1 featured on top, 2 below */
.image-layout-three {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem;
}
.featured-image {
  width: 100%;
  overflow: hidden;
}
.featured-image img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;
}
.bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}
.bottom-image {
  overflow: hidden;
}
.bottom-image img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

/* Layout: 2 images - side by side, larger */
.image-layout-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0.5rem;
}
.large-image {
  overflow: hidden;
}
.large-image img {
  width: 100%;
  height: auto;
  display: block;
}

/* Fallback grid */
.image-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0.5rem;
}
.image-item {
  overflow: hidden;
}
.image-item img {
  width: 100%;
  height: auto;
  display: block;
}

@media print {
  .featured-image img {
    height: 260px;
  }
  .bottom-image img {
    height: 200px;
  }
  .large-image img {
    height: auto;
  }
}
</style>
<script>
import invoiceHeader from "./OrderInfo";

export default {
  props: {
    data: Object,
    images: Array,
    sectionTitle: String,
    pageLabel: {
      type: String,
      default: "",
    },
    hidden: Boolean,
    layout: {
      type: String,
      default: "default",
    },
  },
  components: {
    invoiceHeader,
  },
};
</script>
